import { visserApi } from './visserApi';
const getWorkOrdersListWithClient = async () => {
    return await visserApi.get('Quotation/GetWorkOrdersListWithClient');
};
const createQuotation = async (createdQuotation) => {
    return await visserApi.post('Quotation/Create', createdQuotation);
};
const getAllQuotations = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Quotation/GetAllQuotations?PageNumber=${request.pageNumber}&PageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const updateQuotations = async (quotationId, updateQuotationDto) => {
    return await visserApi.put(`Quotation/Update/${quotationId}`, updateQuotationDto);
};
const getQuotationById = async (quotationId) => {
    return await visserApi.get(`Quotation/GetById/${quotationId}`);
};
const getWorkOrdersListWithClientAsync = async (workOrderNumber) => {
    return await visserApi.get(`Quotation/GetWorkOrdersListWithClient/${workOrderNumber}`);
};
const getAllQuotationStatus = async () => {
    return await visserApi.get('Quotation/GetAllQuotationsStatus');
};
const createQuotationAmount = async (createQuotationAmount) => {
    return await visserApi.post('Quotation/CreateQuotationAmount', createQuotationAmount);
};
const getAllQuotationAmounts = async (quotationId) => {
    return await visserApi.get(`Quotation/GetAllQuotationAmounts/${quotationId}`);
};
const updateQuotationAmount = async (updateQuotationAmount) => {
    return await visserApi.put(`Quotation/UpdateQuotationAmount`, updateQuotationAmount);
};
const getQuotationAmountById = async (id) => {
    return await visserApi.get(`Quotation/GetQuotationAmountById/${id}`);
};
const getQuotationPreview = async (id) => {
    return await visserApi.get(`Quotation/GetQuotationPreview/${id}`);
};
const deleteQuotationAmount = async (id) => {
    return await visserApi.delete(`Quotation/DeleteQuotatonAmount/${id}`);
};
const updateQuotationAmountPosition = async (updateQuotationAmountPosition) => {
    return await visserApi.put(`Quotation/UpdateQuotationAmountPosition`, updateQuotationAmountPosition);
};
const deleteQuotationById = async (id) => {
    return await visserApi.delete(`Quotation/Delete/${id}`);
};
const updateBulkQuotationAmount = async (updateQuotationAmountPosition) => {
    return await visserApi.put(`Quotation/UpdateBulkQuotationAmount`, updateQuotationAmountPosition);
};
const getQuotationNumber = async (workOrderId) => {
    return await visserApi.get(`Quotation/GetQuotationNumber/${workOrderId}`);
};
const generateQuotationPdf = async (materials) => {
    const response = await visserApi.post(`Quotation/GenerateQuotationPdf`, materials);
    return response.data;
};
const getAllShippingMethod = async () => {
    return await visserApi.get(`Quotation/GetShippingMethods`);
};
const generateQuotationPdfAsAttachment = async (materials) => {
    const response = await visserApi.post(`Quotation/GenerateQuotationPdfAsAttachment`, materials);
    return response.data;
};
const QuotationApi = {
    getWorkOrdersListWithClient,
    createQuotation,
    getAllQuotations,
    updateQuotations,
    getQuotationById,
    getWorkOrdersListWithClientAsync,
    getAllQuotationStatus,
    createQuotationAmount,
    getAllQuotationAmounts,
    updateQuotationAmount,
    getQuotationAmountById,
    deleteQuotationAmount,
    getQuotationPreview,
    updateQuotationAmountPosition,
    deleteQuotationById,
    updateBulkQuotationAmount,
    getQuotationNumber,
    generateQuotationPdf,
    getAllShippingMethod,
    generateQuotationPdfAsAttachment
};
export default QuotationApi;
